import { NgModule, ErrorHandler, Component } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { HttpModule, JsonpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';
//import { CloudSettings, CloudModule } from '@ionic/cloud-angular';
import { File } from '@ionic-native/file';
import { Transfer } from '@ionic-native/transfer';
import { Network } from '@ionic-native/network'
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';
import { CalendarComponent } from 'ionic2-calendar/calendar';
//import { IonAlphaScrollModule } from 'ionic2-alpha-scroll';
import { NgCalendarModule } from 'ionic2-calendar';
import { CalendarService } from 'ionic2-calendar/calendar.service';
import { Calendar } from '@ionic-native/calendar';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { StatusBar } from '@ionic-native/status-bar';
import { Keyboard } from '@ionic-native/keyboard';
import { RouterModule, Routes, Router } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';
import 'expose-loader?jQuery!jquery';
import '../../node_modules/signalr/jquery.signalR.js';
import { SignalRModule, SignalRConfiguration } from 'ng2-signalr';
export function createConfig(): SignalRConfiguration {
  const c = new SignalRConfiguration();
  c.hubName = 'congresso';
  return c;
}

//Pages
import { Apc } from './app.component';
import { AulasPage } from '../pages/aulas/aulas';
import { AtividadePage } from '../pages/atividade/atividade';
import { AgendaPage } from '../pages/agenda/agenda';
import { PalestrantesPage } from '../pages/palestrantes/palestrantes';
import { PalestrantePerfilPage } from '../pages/palestrante-perfil/palestrante-perfil';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { TabsPage } from '../pages/tabs/tabs';
import { BuscaPage } from '../pages/busca/busca';
import { AjudaPage } from '../pages/ajuda/ajuda';
import { SobrePage } from '../pages/sobre/sobre';
import { VideoPage } from '../pages/video/video';
import { ExpositoresPage } from './../pages/expositores/expositores';
import { ExpositorPage } from '../pages/expositor/expositor';
import { ExpositorArquivosPage } from './../pages/expositor-arquivos/expositor-arquivos';
import { ExpositorVideoPage } from './../pages/expositor-video/expositor-video';

//Provider
import { AuthProvider } from '../providers/auth-provider';
import { ConfigProvider } from '../providers/config-provider';
import { UtilProvider } from '../providers/util-provider';
import { CongressoProvider } from '../providers/congresso-provider';
import { UserProvider } from '../providers/user-provider';
import { LecturerProvider } from '../providers/lecturer-provider';
import { AgendaProvider } from '../providers/agenda-provider';
import { SearchProvider } from '../providers/search-provider';
import { GeralProvider } from '../providers/geral-provider';
import { CalendarProvider } from '../providers/calendar-provider';
import { StorageProvider } from '../providers/storage-provider';
import { HubProvider } from '../providers/hub-provider';
import { ExpositorProvider } from './../providers/expositor-provider';

//Components
import { CustomSearchbar } from '../components/custom-searchbar/custom-searchbar';
import { VideoPlayerComponent } from '../components/video-player/video-player.component';
import { CustomAlert } from '../components/custom-alert.component';
import { CustomToastComponent } from '../components/custom-toast/custom-toast';
import { ThemeHelperComponent } from '../components/theme-helper/theme-helper.component';
import { RefreshInfoComponent } from '../components/refresh-info/refresh-info.component';
import { BrowserModule } from '@angular/platform-browser';
import { MenuToolbarComponent } from '../components/menu-toolbar/menu-toolbar.component';


const routes: Routes = [
  {
    path: 'tabs',
    component: TabsPage
  }
];

/*const cloudSettings: CloudSettings = {
  'core': {
    'app_id': 'e3f3ffda'
  },
  'push': {
    'sender_id': '603687486165',
    'pluginConfig': {
      'ios': {
        'badge': true,
        'sound': true
      },
      'android': {
        'iconColor': '#ff0000'
      }
    }
  }
};*/

@NgModule({
  declarations: [
    Apc,
    AulasPage,
    AtividadePage,
    AgendaPage,
    PalestrantesPage,
    PalestrantePerfilPage,
    HomePage,
    LoginPage,
    TabsPage,
    BuscaPage,
    AjudaPage,
    SobrePage,
    VideoPage,
    ExpositoresPage,
    ExpositorPage,
    ExpositorArquivosPage,
    ExpositorVideoPage,
    CustomSearchbar,
    VideoPlayerComponent,
    ThemeHelperComponent,
    RefreshInfoComponent,
    MenuToolbarComponent
  ],
  imports: [
    NgCalendarModule,
    IonicModule.forRoot(Apc, {
      scrollAssist: false,
      autoFocusAssist: false,
      //tabsHideOnSubPages: true,

    }),
    IonicStorageModule.forRoot({
      name: '__apcdb',
      driverOrder: ['sqlite', 'websql', 'indexeddb']
    }),
    SignalRModule.forRoot(createConfig),
    RouterModule.forRoot(routes),
    BrowserModule,
    //IonAlphaScrollModule,
    //CloudModule.forRoot(cloudSettings),
    JsonpModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    Apc,
    AulasPage,
    AtividadePage,
    AgendaPage,
    PalestrantesPage,
    PalestrantePerfilPage,
    HomePage,
    AjudaPage,
    LoginPage,
    TabsPage,
    BuscaPage,
    SobrePage,
    VideoPage,
    ExpositoresPage,
    ExpositorPage,
    ExpositorArquivosPage,
    ExpositorVideoPage,
    CustomSearchbar
  ],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: APP_BASE_HREF, useValue: '/' },
    CalendarComponent,
    CustomAlert,
    CustomToastComponent,
    RefreshInfoComponent,
    VideoPlayerComponent,
    MenuToolbarComponent,
    AuthProvider,
    UserProvider,
    File,
    Network,
    Transfer,
    Camera,
    FilePath,
    Calendar,
    InAppBrowser,
    StatusBar,
    Keyboard,
    ConfigProvider,
    UtilProvider,
    LecturerProvider,
    ExpositorProvider,
    CongressoProvider,
    AgendaProvider,
    SearchProvider,
    GeralProvider,
    StorageProvider,
    CalendarProvider,
    HubProvider
  ]

})


export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts